import styled from 'styled-components'

export const ConfirmationCodeArea = styled.div`
  margin: 10px 0;

  span {
    cursor: default;
  }
`
